import { render, staticRenderFns } from "./TermsAndConditionsDialog.vue?vue&type=template&id=551f760f"
import script from "./TermsAndConditionsDialog.vue?vue&type=script&lang=js"
export * from "./TermsAndConditionsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports